import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { gotoPoster } from '@util'
import style from './style.module.less'
import mainStore from '../store'

@observer
export default class extends Component {
  render() {
    const { banner } = mainStore.posterStore
    const { image_path } = banner

    return image_path ? (
      <div className={style.headerBox} style={{ zIndex: 999 }}>
        <a
          className={style.banner}
          style={{ backgroundImage: `url(${image_path})` }}
          onClick={() => gotoPoster(banner)}
        />
      </div>
    ) : null
  }
}
